import taskTypeLargeIcon from '@atom/components/common/svgIcons/taskTypeLarge.svg';

import classes from './taskCreate.module.css';

const EmptyTaskTemplate = () => {
  return (
    <div className={classes.emptyTaskTemplateContainer}>
      <img src={taskTypeLargeIcon} />
      <div className={classes.emptyTitle}>No Task Templates</div>
      <div className={classes.emptySubtext}>
        Save any existing task as a template and use it in the future.
      </div>
    </div>
  );
};

export default EmptyTaskTemplate;
